import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8.5v7","key":"svg-0"}],["path",{"d":"M9 10l6 4","key":"svg-1"}],["path",{"d":"M9 14l6 -4","key":"svg-2"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-3"}]]

const IconCircleAsterisk = createReactComponent('outline', 'circle-asterisk', 'CircleAsterisk', __iconNode);

export default IconCircleAsterisk;